<div>
    <app-utilities-create-edit (parentComp)="reloadTable($event)"></app-utilities-create-edit>
  </div>
  
  <!-- HEADER -->
  <app-screen-heading [title]="'Utilities'" [hideButtonsOnSmallScreen]="false" [hideBottomBorder]="false">
    <ng-container smallScreenButtons>
      <button (click)="selectUtility()">
        <span class="text">Add Utility</span>
      </button>
      <!-- <button mat-menu-item >
        <span class="text">Upload New</span>
        </button> -->
    </ng-container>
    <ng-container regularButtons>
      <button class="btn" (click)="selectUtility()">
        <span class="text">Add Utility</span>
        <img src="assets/images/icons/add-w.svg" alt="Add icon">
      </button>
      <!-- <button class="btn btn-outline">
        <span class="text">Upload New</span>
        <img src="assets/images/icons/upload.svg" alt="Upload icon">
        </button> -->
    </ng-container>
  </app-screen-heading>
  
  <!-- FILTERS -->
  <app-table-filter [showSearch]="true" [searchPlaceholder]="'Search by Name'"
    (filterChange)="handleChangeFilter($event)">
  </app-table-filter>
  
  <div class="page-table">
    <table>
      <thead>
        <tr class="header-columns">
          <td><span>Name</span></td>
          <td><span>Applications</span></td>
          <td><span>Action</span></td>
        </tr>
      </thead>
  
      <tbody>
        <tr *ngFor="let item of utilities" class="bodyRow clickable actions-click">
          <td><span>{{item.name | hasValue}}</span></td>
          <td><span>{{item.applications | hasValue}}</span></td>
          <td><span class="button-action" title="Edit"><img src="assets/images/icons/edit.jpg" (click)="selectUtility(item.id)" /> </span></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="pagination-wrapper">
    <app-pagination [pageSize]="pageSize" [currentPage]="currentPage" [count]="count" (pageChange)="pageChange($event)">
    </app-pagination>
